import React from "react";
import TaxonomySection from "./TaxonomySection";
import { TAXONOMY_SECTIONS } from "./TaxonomyConfig";
import styles from "./Taxonomy.module.css";


const TaxonomyManager = () => {
  return (
    <div className={styles.taxonomyManager}>
      <h2 className={styles.heading}>Taxonomy Manager</h2>
      <p className={styles.description}>Manage all content classification categories used across the platform</p>

      {TAXONOMY_SECTIONS.map((section) => (
        <TaxonomySection
          key={section.type}
          type={section.type}
          icon={section.icon}
          title={section.title}
        />
      ))}
    </div>
  );
};

export default TaxonomyManager;